import React, { useEffect } from 'react';
import { format, addWeeks, parse } from 'date-fns';
import { Link } from 'react-router-dom';
import { useCallback, ReactElement } from 'react';
import { Panel } from '../../generated/graphql';
import { useUserContext } from '../../contexts/user-context';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import { red } from '@mui/material/colors';

import {
    Add,
    CopyAll,
    Info,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight, MoreHoriz, OpenInNew,
    Visibility,
} from "@mui/icons-material";
import {
    Button,
    FormControlLabel,
    styled,
    Switch,
    Tooltip,
    Link as MuiLink,
    ButtonGroup,
    IconButton,
} from "@mui/material";
import { IsoDatePicker } from "../../components/IsoDatePicker";
import WaitSpinner from "../../components/wait-spinner";
import { NonIdealState } from "../../components/NonIdealState";
import { useToast } from "../../contexts/toast";
import { underChallengeIcon } from "../../utils/icons";
import { Icon as IconifyIcon } from '@iconify/react';

const PanelBookingsGrid = styled('div', {
    name: 'PanelBookings', slot: 'grid',
    shouldForwardProp: (prop) =>
        prop !== 'error' && prop !== 'color' && prop !== 'variant' && prop !== 'sx',
    overridesResolver: (props, styles) => [
        styles.grid
    ]
})({});

const PanelGridRow = (props: { row: any, clickDateInspect: any, clickBookPanelDate: any, viewWeekNum: any }) => {
    const row = props.row;
    const clickDateInspect = props.clickDateInspect;
    const clickBookPanelDate = props.clickBookPanelDate;
    const seeSites = useUserContext().hasPermission('sites.edit');
    const { toast } = useToast();
    function column(col, weekNum, panelId, panel) {
        if (!col) return <div className="panel-booking-table__cell wait-panel-booking" />;
        const challengeStatus = col?.campaign_challenge_booking_id > 0;
        const count = col.type === 'FULL' ? '(' + col.count + ')' : '(' + col.count + '/' + panel.number_of_slots + ')';
        return (
            <div
                className={['panel-booking-table__cell', 'booking-status__bg__' + (col.status ? col.status.toLowerCase() : 'empty'), (col.panelStatus !== 'LIVE' ? 'toc-poc' : ''),
                    (challengeStatus ? 'booking-status__challenged' : '')].join(' ')}>
                {challengeStatus &&
                    <div className="panel-status__challenged__indicator" />
                }
                {col.status !== 'BLANK' ?
                    <span>
                        {count} {col.campaignName} (C/None)</span> : <span>&nbsp;</span>
                }
                {col.panelStatus === 'LIVE' && (
                    <div style={{ textAlign: 'center' }}>
                        <Button size="small" data-week={weekNum} data-panel_id={panelId} onClick={clickBookPanelDate}>
                            <Add />
                        </Button>
                        {col.status !== 'BLANK' && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', width: col.instruction ? 'auto' : '100%', justifyContent: col.instruction ? 'flex-start' : 'center', }}>
                                <Button size="small" data-week={weekNum} data-panel_id={panelId} onClick={clickDateInspect}>
                                    <Visibility />
                                </Button>

                                {col.instruction && (
                                    <Tooltip title={`Instruction: ${col.instruction}`} arrow>
                                        <Info fontSize="small" sx={{ cursor: 'pointer', color: 'red' }} />
                                    </Tooltip>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
    return React.useMemo(() => {
        console.log('[PanelGrid]', 'DRAW ROW', row, row?.site?.name, row?.panel);
        if (!row || !row.site) {
            console.log('[PanelGrid]', 'bogus data', row);
            return null;
        }
        const dates = {};
        row.panelBookingDatesSummary.forEach(function (panelBookingDateSummary) {
            dates[panelBookingDateSummary.weekNumber] = panelBookingDateSummary;
        });
        const copyPopup = function () {
            function listener(e) {
                const str = '<div class="site-popup"><h3>' + row.site?.name + '</h3><img src="' + (row.site?.thumbnail ?? '') + '"/>' +
                    '<div class="site-popup__desc">' + (row.site?.descriptionHTML ?? '') + '<br/>' +
                    (row.site.address1 ?? '') + '<br/>' + (row.site?.address2 ?? '') + '<br/>' + (row.site?.postcode ?? '') + '</div></div>';
                e.clipboardData.setData("text/html", str);
                e.clipboardData.setData("text/plain", str);
                e.preventDefault();
            }

            document.addEventListener("copy", listener);
            document.execCommand("copy");
            toast('Description copied to clipboard', { variant: 'success' });
            document.removeEventListener("copy", listener);
        };
        return (
            <div className="panel-booking-table__row" key={row.id}>
                <div className="panel-booking-table__3row">
                    <div>{row.site.boroughOrRegion}</div>
                    <div>{row.site.siteStructure?.name}</div>
                    <div></div>
                </div>
                <div className="panel-booking-table__3row">
                    {row.site.site_code ?
                        <div>{row.site.site_code}</div>
                        : <div>&nbsp;</div>
                    }
                    <div>&nbsp;</div>
                    <div>{row.panel}</div>
                </div>
                <div className="panel-booking-table__3row">
                    <div className={
                        (row.site?.style?.label ? 'site-style-' + row.site.style.label.replace(/[^a-zA-Z0-9]/, '-').toLowerCase() : '') +
                        ' panel-booking-table__site-name'}>
                        {seeSites && <Tooltip classes={{ tooltip: 'nowidth' }} title={<div className="site-popup"><img src={row.site.thumbnail ?? ''} />
                            <div className="site-popup__desc"><div dangerouslySetInnerHTML={{
                                __html: row.site.descriptionHTML ?? ''
                            }}></div><br />{row.site.address1 ?? ''}<br />{row.site.address2 ?? ''}<br />{row.site.postcode}
                            </div>
                        </div>}>
                            <MuiLink component={Link} to={'/sites/' + row.site.id}>{row.site.name}</MuiLink></Tooltip>
                        }
                        {(!seeSites) && <Tooltip classes={{ tooltip: 'nowidth' }}
                            title={<div className="site-popup"><img src={row.site.thumbnail ?? ''} />
                                <div className="site-popup__desc" dangerouslySetInnerHTML={{
                                    __html: row.site.descriptionHTML ?? ''
                                }}></div>
                            </div>}>
                            <span className="hover-hint">{row.site.name}</span>
                        </Tooltip>
                        }
                        <Tooltip title={<ButtonGroup size="small">
                            <Tooltip title="Copy site image, description and address to clipboard">
                                <Button size="small" variant="contained" onClick={copyPopup}><CopyAll /></Button>
                            </Tooltip>
                            <Tooltip title="Link to live site profile">
                                <Button variant="contained" component={"a"} href={row.site.externalLink}
                                    rel="noreferrer" target="_blank"><OpenInNew /></Button>
                            </Tooltip>
                        </ButtonGroup>}>
                            <MoreHoriz sx={{ position: 'absolute', top: 0, right: 0 }} fontSize="small" />
                        </Tooltip>
                    </div>
                    <div
                        className={row.pack?.style?.label ? 'pack-style-' + row.pack.style.label.replace(/[^a-zA-Z0-9]/, '-').toLowerCase() : ''}>{row.pack?.label}</div>
                    <div>{row.site.distributor?.name}</div>
                    <div>{row.site.is_dashboard_site && <FiberNewIcon fontSize="large" sx={{ color: red[500] }} />}</div>
                </div>
                {column(dates[props.viewWeekNum], props.viewWeekNum, row.id, row)}
                {column(dates[props.viewWeekNum + 1], props.viewWeekNum + 1, row.id, row)}
                {column(dates[props.viewWeekNum + 2], props.viewWeekNum + 2, row.id, row)}
                {column(dates[props.viewWeekNum + 3], props.viewWeekNum + 3, row.id, row)}
                {column(dates[props.viewWeekNum + 4], props.viewWeekNum + 4, row.id, row)}
            </div>);
    }, [row, clickBookPanelDate]);
}

export const PanelGrid = (props: {
    toggleFrozen: (boolean) => void, isFrozen: boolean, viewWeekNum: number, viewWeek: Date, loading: boolean, error: any, order: number[], results: Panel[] | null, inspectDate: (panelId: number, week: number) => void, bookDate: (panelId: number, week: number) => void,
    changeWeek: (newDate: Date) => void
}) => {
    console.log('render panelgrid with', props.results, props.loading);
    //props.loading = true;
    const [maxRows, setMaxRows] = React.useState(0);
    useEffect(() => {
        if (props.results) {
            setMaxRows(0);
        }
    }, [props.results]);
    const weekUpDown = useCallback((evt) => {
        const el = evt.target.closest('[data-weeks]');
        props.changeWeek(addWeeks(props.viewWeek, parseInt(el.dataset.weeks)));
    }, [props.viewWeek, props.changeWeek]);

    const clickDateInspect = useCallback((evt) => {
        const el = evt.target.closest('[data-week]');
        props.inspectDate(el.dataset.panel_id, parseInt(el.dataset.week));
    }, [props.inspectDate]);
    const evtChangeWeek = useCallback(({ target }) => {
        props.changeWeek(parse(target.value, 'yyyy-MM-dd', new Date()));
    }, [props.changeWeek]);
    const clickBookPanelDate = useCallback((evt) => {
        const el = evt.target.closest('[data-week]');
        props.bookDate(el.dataset.panel_id, parseInt(el.dataset.week));
    }, [props.bookDate]);

    const toggleFrozen = (evt) => {
        props.toggleFrozen(evt.target.checked);
    };
    const ret: ReactElement[] = [];

    ret.push(<div className="panel-booking-table__header__row" key="header">
        <div className="panel-booking-table__header__options">
            <div><IconButton data-weeks="-4" onClick={weekUpDown} size="small"><KeyboardDoubleArrowLeft
                fontSize="inherit" /></IconButton><IconButton
                    onClick={weekUpDown} data-weeks="-1" size="small"><KeyboardArrowLeft fontSize="inherit" /></IconButton>
                <IsoDatePicker name="not-relevant" value={format(props.viewWeek, 'yyyy-MM-dd')} onChange={evtChangeWeek}
                    mondayOnly={true} />
                <IconButton data-weeks="1" onClick={weekUpDown} size="small"><KeyboardArrowRight
                    fontSize="inherit" /></IconButton><IconButton
                        onClick={weekUpDown} data-weeks="4" size="small"><KeyboardDoubleArrowRight
                        fontSize="inherit" /></IconButton>
            </div>
            <>
                <FormControlLabel disabled={!props.results}
                    control={<Switch onChange={toggleFrozen} checked={props.isFrozen} />}
                    disableTypography={true} label="Freeze" />
                {props.results &&
                    <span
                        className="panel-booking-table__header_matches">{props.results?.length ? (props.results?.length ?? 0) + ' matching panels' : 'No matching panels'}</span>
                }
            </>
        </div>
        <div>{format(props.viewWeek, 'dd MMM yyyy')}</div>
        <div>{format(addWeeks(props.viewWeek, 1), 'dd MMM yyyy')}</div>
        <div>{format(addWeeks(props.viewWeek, 2), 'dd MMM yyyy')}</div>
        <div>{format(addWeeks(props.viewWeek, 3), 'dd MMM yyyy')}</div>
        <div>{format(addWeeks(props.viewWeek, 4), 'dd MMM yyyy')}</div>
    </div>);
    if (props.loading) {
        console.log('PANELGRID IS LOADING?');
        ret.push(<WaitSpinner variant="overlay" key="wait" />);
    }
    if (props.error) return <NonIdealState title="An Error has occurred" severity="error"
        message={props?.error?.message} />;
    /*
        const renderRow = (row:any) => {

        };
    */

    if (props.results && props.results.length) {
        //var panels = props.results;
        /*var panels = props.results.filter(function (v) {
            return exclusionIds.indexOf(v.id) === -1;
        });*/
        /*for(let i=0;i<props.results.length;i++) {
            //for(let i=0;!(i>=maxRows || i>=props.results.length);i++) {
            ret.push(<PanelGridRow key={props.results[i].id} row={props.results[i]} clickBookPanelDate={clickBookPanelDate}
                clickDateInspect={clickDateInspect}
                viewWeekNum={props.viewWeekNum}/>);
        }*/
        /*
        if(maxRows<props.results.length) {
            setTimeout(()=>{
                console.log('timeout for render...');
                setMaxRows((v)=>v+200);
            },400);
        }*/
        ret.push(...props.order.map((id) => (
            <PanelGridRow key={id} row={props.results[id]} clickBookPanelDate={clickBookPanelDate}
                clickDateInspect={clickDateInspect}
                viewWeekNum={props.viewWeekNum} />)));
    }
    return <PanelBookingsGrid className="panel-booking-table">
        {ret}
    </PanelBookingsGrid>;
}